
export const getUserCblcDigit = (cblc: number) => {
    const iBroker = 4090;
    const iAccount = cblc;
    const arrBrokerAccount = [
        Math.trunc(iAccount % 10),
        Math.trunc(iAccount % 100 / 10),
        Math.trunc(iAccount % 1000 / 100),
        Math.trunc(iAccount % 10000 / 1000),
        Math.trunc(iAccount % 100000 / 10000),
        Math.trunc(iBroker % 10),
        Math.trunc(iBroker % 100 / 10),
        Math.trunc(iBroker % 1000 / 100),
        Math.trunc(iBroker % 10000 / 1000),
        Math.trunc(iBroker % 100000 / 10000),
        Math.trunc(iAccount % 1000000 / 100000),
        Math.trunc(iAccount % 10000000 / 1000000),
        Math.trunc(iAccount % 100000000 / 10000000),
    ];
    
    const arrFatores = [2 , 3, 4 , 5, 6, 7, 8, 9]; 
    let iSoma = 0; 
    for(let index = 0; index < arrBrokerAccount.length; index++){
        iSoma += arrBrokerAccount[index] * arrFatores[index % arrFatores.length]
    }
    
    return ((iSoma*10)%11)%10; 
}
